export default __webpack_public_path__ + "static/media/panel-flooring-installation.8a3d3126.jpg";